<template>
  <v-card
    style="border-radius:5px;height:100%;"
    :style="{ 'opacity': activity.Availability.finished ? '0.3' : '1'}"
    light
  >
    <v-layout
      row
      wrap
      style="height:100%;"
    >
      <v-flex
        xs4
        style="padding: 0;height:100%;"
      >
        <v-img
          :src="activity.Image"
          :lazy-src="activity.Image"
          :style="{ 'margin-left': isSimulation ? '10px' : '0px'}"
          height="100%"
          width="90%"
          aspect-ratio="1.7"
          class="grey lighten-2"
          style="border-radius: 5px 0 0px 5px;"
        />
      </v-flex>
      <v-flex
        :style="{ 'color': configColor.ColorContent}"
        xs8
      >
        <v-layout
          row
          wrap
          style="margin-top:5px;margin-bottom:0px;"
        >
          <v-flex
            xs8
            style="font-size:16px;text-align: left;padding-bottom:5px;line-height:1.2;"
            :style="{ 'color' : color3 ? color3 : '#666666'}"
          >
            {{ activity.Title.toUpperCase() }}
          </v-flex>
          <v-flex
            xs4
            style="text-align: right;padding-right: 15px;padding-bottom:0px;"
          >
            <add-calendar
              v-if="!totem && activity && !activity.Availability.finished"
              :start="activity.Date"
              :end="activity.Date"
              :startTime="activity.TimeStart"
              :endTime="activity.TimeEnd"
              :title="activity.Title"
              :description="activity.Description ? activity.Description : ''"
              :color="`${color3 ? color3 : backgrounColor}`"
              :active="daysToAdd === 0 && activity.Availability.time"
            />
          </v-flex>
          <v-flex
            xs12
            style="text-align: left;padding-top: 0px;padding-bottom: 0px;"
          >
            <v-icon
              dark
              class="activity-button"
              style="margin-left: 0px;font-weight: 500;font-size: 19px;"
              :style="{ 'color': activity.Availability.time && activity.Availability.daysToAdd === '0' ? 'rgb(85,173,11)' : color4 ? color4 : '#666666'}"
            >
              mdi-clock-outline
            </v-icon>
            <span
              style="font-weight: 500;font-size: 19px;"
              :style="{ 'color': activity.Availability.time && activity.Availability.daysToAdd === '0' ? 'rgb(85,173,11)' : color4 ? color4 : '#666666'}"
            >
              {{ activity.TimeStart.substring(0, 5) }}-{{ activity.TimeEnd.substring(0, 5) }}
            </span>
          </v-flex>
          <v-flex
            xs12
            style="text-align: left;padding-top: 0px;padding-bottom: 12px;"
          >
            <span                  
              :style="{ 'opacity': activity.Description && activity.Description.length > 0 ? '1' : '0', 'color': color6 ? color6 : '#999999'}"
              style="font-size: 12px;"
              v-html="activity.Description && activity.Description.length > 0 ? activity.Description : '.'"
            >
              <!-- {{ activity.Description && activity.Description.length > 0 ? activity.Description : '.' }} -->
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
  import AddCalendar from './AddCalendar'
  export default {
    components: {
      AddCalendar,
    },
    props: {
      activity: {
        type: Object,
        default: null,
      },
      color1: {
        type: String,
        default: null,
      },
      color2: {
        type: String,
        default: null,
      },
      color3: {
        type: String,
        default: null,
      },
      color4: {
        type: String,
        default: null,
      },
      color6: {
        type: String,
        default: null,
      },
      daysToAdd: {
        type: Number,
        default: null,
      },
      configColor: {
        type: Object,
        default: null,
      },
      backgrounColor: {
        type: String,
        default: null,
      },
      totem: {
        type: Boolean,
        default: false,
      },
      isSimulation: {
        type: Boolean,
        default: false,
      }
    },
  }
</script>
